import React, { useContext } from "react";
import { Typography, FormControl, Select, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../Context/Langcontext";
import Tooltips from "@material-ui/core/Tooltip";
import { getUsageStat } from "../../API/Usage";
import { KeyboardDatePicker } from "@material-ui/pickers";

const useStyle = makeStyles((theme) => ({
  textfield: {
    fontWeight: 200,
    fontSize: "1rem",
  },
  text: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#595A5A",
  },
  font: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  select: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  dateinput: {
    fontWeight: 200,
    fontSize: "1rem",
    marginTop: 0,
  },
}));

const Timeperiod = ({
  state,
  setState,
  setSum,
  convertiso,
  convertiso23,
  date,
  setDate,
  setloading,
}) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const getData = async (e) => {
    let input = "";
    if (e === "lastweek") {
      let d1 = new Date();
      let d2 = new Date();
      d1.setDate(d1.getDate() - 7);
      let d1utc = new Date(convertiso(d1));
      let d2utc = new Date(convertiso23(d2));
      let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
      let ts2tamputc = Math.floor(d2utc.getTime() / 1000);
      input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
      const get = await getUsageStat(input);
      if (get.status.code === 200) {
        setloading(true);
        setTimeout(() => {
          setloading(false);
          setSum(get.data);
        }, 1000);
      }
    } else if (e === "lastmonth") {
      let d1 = new Date();
      let d2 = new Date();
      d1.setMonth(d1.getMonth() - 1);
      let d1utc = new Date(convertiso(d1));
      let d2utc = new Date(convertiso23(d2));
      let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
      let ts2tamputc = Math.floor(d2utc.getTime() / 1000);
      input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
      const get = await getUsageStat(input);
      if (get.status.code === 200) {
        setloading(true);
        setTimeout(() => {
          setloading(false);
          setSum(get.data);
        }, 1000);
      }
    } else if (e === "lastyear") {
      let d1 = new Date();
      let d2 = new Date().toUTCString();
      d1.setFullYear(d1.getFullYear() - 1);
      let d1utc = new Date(convertiso(d1));
      let d2utc = new Date(convertiso23(d2));
      let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
      let ts2tamputc = Math.floor(d2utc.getTime() / 1000);
      input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
      const get = await getUsageStat(input);
      if (get.status.code === 200) {
        setloading(true);
        setTimeout(() => {
          setloading(false);
          setSum(get.data);
        }, 1000);
      }
    }
  };

  const getPeriod = async (e) => {
    let input = "";
    if (state.datetype === "customperiod") {
      if (date.start !== "" && e !== "") {
        let d1 = date.start;
        let d2 = e;

        let d1utc = new Date(convertiso(d1));
        let d2utc = new Date(convertiso23(d2));
        let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
        let ts2tamputc = Math.floor(d2utc.getTime() / 1000);
        input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
        const get = await getUsageStat(input);
        if (get.status.code === 200) {
          setloading(true);
          setTimeout(() => {
            setloading(false);
            setSum(get.data);
          }, 1000);
        }
      } else {
      }
    }
  };
  return (
    <div style={{ margin: "2rem" }}>
      <Grid container>
        <Grid item md={4} sm={6} xs={12}>
          <Tooltips title="เลือกช่วงเวลาในการแสดงผล" placement="top-start">
            <Typography className={classes.text}>{lang.TimePeriod}</Typography>
          </Tooltips>
        </Grid>
        <Grid item md={2} sm={6} xs={12}>
          <FormControl fullWidth>
            <Select
              native
              inputProps={{
                name: "view",
                id: "view-native-simple",
              }}
              className={classes.select}
              value={state.datetype}
              onChange={(e) => {
                getData(e.target.value);
                setState({ ...state, datetype: e.target.value });
                setDate({
                  ...date,
                  start: new Date(),
                  end: new Date(),
                  set: true,
                });
              }}
            >
              <option value={"lastweek"}> {lang.Lastweek}</option>
              <option value={"lastmonth"}>{lang.Lastmonth}</option>
              <option value={"lastyear"}>{lang.Lastyear}</option>
              <option value={"customperiod"}>{lang.CustomPeriod}</option>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <form
            noValidate
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            {/* <Typography className={classes.font}>{lang.From}</Typography> */}
            <KeyboardDatePicker
              disableToolbar
              autoOk
              disabled={state.datetype !== "customperiod"}
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              id="date-picker-inline"
              value={date.start}
              className={classes.dateinput}
              onChange={(e) => {
                setDate({ ...date, start: e, set: false });
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              InputProps={{
                className: classes.textfield,
              }}
            />

            {/* <TextField
              id="datefrom"
              type="date"
              disabled={state.datetype !== "customperiod"}
              value={date.start}
              onChange={(e) => {
                setDate({ ...date, start: e.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                className: classes.textfield,
              }}
            /> */}
            {/* <Typography className={classes.font}>{lang.To}</Typography> */}
            <KeyboardDatePicker
              disableToolbar
              autoOk
              disabled={date.set}
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              className={classes.dateinput}
              id="date-picker-inline"
              value={date.end}
              onChange={(e) => {
                setDate({ ...date, end: e });
                getPeriod(e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              InputProps={{
                className: classes.textfield,
              }}
            />

            {/* <TextField
              id="dateto"
              type="date"
              disabled={date.start === ''}
              value={date.end}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setDate({ ...date, end: e.target.value });
                getPeriod(e.target.value);
              }}
              style={{}}
              InputProps={{
                className: classes.textfield,
              }}
            /> */}
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Timeperiod;
